import * as React from 'react';
import {requestNavigation} from '../commons/unsavedChanges/unsavedChangesGuard';

export const navigationRef = React.createRef();

export function navigate(name, params) {
  requestNavigation(() => navigationRef.current?.navigate(name, params));
}

export function reset(name, params) {
  requestNavigation(() =>
    navigationRef.current?.reset({
      index: 0,
      routes: [{name: name, params: params}]
    })
  );
}
